import React, { FC, createContext, useState, useEffect } from "react";
import config from "../../staticConfig";
import axios from "axios";
import { TypeCallerInfor } from "../../types/TypeContact";

interface TypeContextCallerInfor {
  exsitingCaller: boolean;
  callerInfor: TypeCallerInfor;
  updateCallerInfor: any;
}

export const CallerInforContext = createContext<TypeContextCallerInfor>({
  exsitingCaller: false,
  callerInfor: { customerName: "", company: "", phoneNumber: "" },
  updateCallerInfor: () => {},
});

export const CallerInforProvider: FC<{}> = ({ children }) => {
  const [callerExist, setCallerExist] = useState<boolean>(false);
  const [caller, setCaller] = useState<TypeCallerInfor>({
    customerName: "",
    company: "",
    phoneNumber: "",
  });

  const updateCallerInfor = (callerInfor: TypeCallerInfor) => {
    setCaller(callerInfor || {
      customerName: "",
      company: "",
      phoneNumber: "",
    });
    setCallerExist(callerInfor ? true: false);
  };

  useEffect(() => {
    const url = new URL(window.location.href);
    const phone = url.searchParams.get("phone");
    if (Boolean(phone)) {
      (async () => {
        const phoneNumber = phone!.trim();
        const endpointUrl = `${config.apiGatewayEndpoint}/customersearch?searchContent=${phoneNumber}&matchType=PHONENUMBER`;
        try {
          const response = await axios.get(endpointUrl);
          if (response.data.length > 0) {
            setCaller(response.data[0]);
            setCallerExist(true);
          } else {
            setCaller({
              customerName: "",
              company: "",
              phoneNumber: `+${phoneNumber}`,
            });
          }
        } catch (error) {
          console.error("Retrieve customer profile error", error);
        }
      })();
    }
  }, []);

  return (
    <CallerInforContext.Provider
      value={{
        exsitingCaller: callerExist,
        callerInfor: caller,
        updateCallerInfor,
      }}
    >
      {children}
    </CallerInforContext.Provider>
  );
};
